import ContentDialog from '@shared/components/core/dialog/ContentDialog';
import { DialogChildContentWrapper } from '@shared/components/core/dialog/CoreDialogStyles';
import StyledTextField from '@shared/components/core/field/StyledTextField';
import { usePasswordManager } from '@shared/hooks/userSettings/usePasswordManagement';
import { useTranslation } from 'react-i18next';

export interface IPasswordResetDialogProps {
    open: boolean;
    onClose: () => void;
}

export default function PasswordResetDialog({ open, onClose }: IPasswordResetDialogProps) {
    const { t } = useTranslation();
    const {
        oldPassword,
        setOldPassword,
        newPassword,
        setNewPassword,
        confirmNewPassword,
        setConfirmNewPassword,
        handleSavePassword,
    } = usePasswordManager();

    const handleConfirm = async () => {
        await handleSavePassword();
        // Only close if successful - the handleSavePassword will show error if not
        onClose();
    };

    return (
        <ContentDialog
            open={open}
            onClose={onClose}
            onCancel={onClose}
            onConfirm={handleConfirm}
            title={t('common:account.password.change')}
            confirmButtonText={t('common:account.password.update')}
            cancelButtonText={t('common:cancel')}
            maxWidth="sm"
            fullWidth>
            <DialogChildContentWrapper>
                <StyledTextField
                    fullWidth
                    label={t('common:account.password.old')}
                    type="password"
                    placeholder={t('common:account.password.current')}
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                />
                <StyledTextField
                    fullWidth
                    label={t('common:account.password.new')}
                    type="password"
                    placeholder={t('common:account.password.desired')}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                />
                <StyledTextField
                    fullWidth
                    label={t('common:account.password.confirm')}
                    type="password"
                    placeholder={t('common:account.password.desired')}
                    value={confirmNewPassword}
                    onChange={(e) => setConfirmNewPassword(e.target.value)}
                />
            </DialogChildContentWrapper>
        </ContentDialog>
    );
}
